import { createGlobalStyle }  from "styled-components";

export const  GlobalStyles = createGlobalStyle`
  margin: 0;
  padding: 0;
  box-sizing:  border-box;
  font-family: 'Montserrat', sans-serif;
  min-height: 100%;
  
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg,  #2633AA 15.86%,  #3744B9 53.76%,  #298D8D 83.71%);
  background-blend-mode: darken; 
`;